import protoRoot from "../proto-root";

const name = "refreshActivityLogRpcRequest";

function create() {
  const RefreshActivityLogRpcRequest = protoRoot.lookupType(
    "comm.RefreshActivityLogRpcRequest"
  );

  const payload = {};

  const request = RefreshActivityLogRpcRequest.create(payload);
  return { payload: request, name };
}

export default {
  create,
  name
};
